// REUSABLE STYLES

export const loginButton = {
  width: '100%',
};

export const noOverflow = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const stageDetailText = (theme: any) => {
  return {
    fontWeight: 700,
    marginLeft: 'auto',
    marginRight: 'auto',
  };
};

export const cancelButton = {
  backgroundColor: 'white',
  color: 'black',
};

export enum Color {
  BLACK = 'black',
  GREEN_DEEP = 'greenDeep',
  ORANGE_DARK = 'orangeDark',
  GREY_MID = 'greyMid',
  GREY_WHITE = 'greyWhite',
  GREY_LIGHT = 'greyLight',
  WHITE = 'white',
}
